import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ImageResource } from '../../resources/image.resource';
import { MatchTenantParams } from '../../../tenancy/util/tenant-params';

declare const FileReader: any;

@Component({
	selector: 'ws-img',
	templateUrl: 'image.component.html',
	styleUrls: ['image.component.scss'],
})
export class ImageComponent implements OnChanges {
	@Input() imageId?: string; // imageId and imageFile are mutually exclusive.
	@Input() imageFile?: any; // If both are set imageId is preferred.

	@Input() alt?: string;

	private _imageUrl?: string;
	private _resolvedImage?: any;

	constructor(private imageResource: ImageResource, private _domSanitizer: DomSanitizer) {}

	get domSanitizer() {
		return this._domSanitizer;
	}

	ngOnChanges(changes: SimpleChanges): void {
		this.resolveImageUrl(this.imageId);

		if (!this.imageId) {
			// Prefer imageId
			this.resolveImageFile(this.imageFile);
		}
	}

	get imageUrl() {
		return this._imageUrl;
	}

	get resolvedImage() {
		return this._resolvedImage;
	}

	private resolveImageUrl(imageId?: string) {
		if (!!imageId) {
			this.imageResource.get.path(Object.assign({ imageId }, new MatchTenantParams())).then((res) => {
				this._imageUrl = res;
			});
		} else {
			this._imageUrl = undefined;
		}
	}

	private resolveImageFile(file: any) {
		if (!!file && typeof file !== 'string') {
			const reader = new FileReader();
			reader.onload = (e: any) => {
				this._resolvedImage = e.target.result;
			};
			reader.readAsDataURL(file);
		} else if (file && typeof file === 'string') {
			this._resolvedImage = file;
		} else {
			this._resolvedImage = undefined;
		}
	}
}
